import { RefObject } from 'preact';

import CameraSelector from '@/components/HabitatLiveStreamPlayer/Controls/CameraSelector';
import { zlSwitchCamera } from '@/components/icons';
import { useLiveStreamPlayerStateContext } from '@/components/LiveStreamPlayer/contexts';
import LiveStreamPlayerControlsMinimized from '@/components/LiveStreamPlayer/LiveStreamPlayerControls/Minimized';
import { FullscreenControlButton } from '@/components/VideoControls/buttons';

interface HomeLiveStreamPlayerMobileControlsProps {
  containerRef: RefObject<HTMLDivElement>;
  onMutedChange: (newValue: boolean) => void;
}

const HomeLiveStreamPlayerMobileControls = ({ containerRef, onMutedChange }: HomeLiveStreamPlayerMobileControlsProps) => {
  const { requestFullscreenFromIFrame } = useLiveStreamPlayerStateContext();

  return (
    <LiveStreamPlayerControlsMinimized.Container className="group-data-[mini-mode=true]/home-player-container:hidden">
      <LiveStreamPlayerControlsMinimized.ExpandableControls
        renderControls={() => (
          <>
            <LiveStreamPlayerControlsMinimized.PlayPauseButton />
            <LiveStreamPlayerControlsMinimized.MuteControlButton onValueChange={onMutedChange} />
            <FullscreenControlButton
              fullscreenElementRef={containerRef}
              onFailToFullscreen={requestFullscreenFromIFrame}
              renderButton={({ label, icon, onClick }) => (
                <LiveStreamPlayerControlsMinimized.IconButton label={label} icon={icon} onClick={onClick} />
              )}
            />
            <CameraSelector
              renderButton={({ onClick }) => (
                <LiveStreamPlayerControlsMinimized.IconButton
                  label="Switch camera"
                  icon={zlSwitchCamera}
                  onClick={onClick}
                />
              )}
            />
          </>
        )}
      />
    </LiveStreamPlayerControlsMinimized.Container>
  );
};

export default HomeLiveStreamPlayerMobileControls;
